import { formatCurrency } from '../functions';

export default class Reservations {
    constructor() {
        const a = document.querySelectorAll('form[data-reservation-id]');
        this.reservations = Array.prototype.map.call(a, form => new Reservation(form));
    }
}

const ReservationMode = {
    initial: 0,
    partialRelease: 1,
    changeSeat: 2,
    changeTicket: 3
};


class Reservation {
    constructor(el) {
        this.form = el;
        const a = el.querySelectorAll('.reservation-item');
        this.items = Array.prototype.map.call(a, item => new ReservationItem(item, this));
        this.mode = ReservationMode.initial;
        this.modal = el.querySelector('.modal');        
        this.buttons = {};
        this.buttons.changeSeats = el.querySelector('.acc-button-change-seats');
        this.buttons.changeTickets = el.querySelector('.acc-button-change-tickets');
        this.buttons.release = el.querySelector('.acc-button-release');
        this.buttons.reset = el.querySelector('.acc-button-reset');

        this.accept = {};
        this.accept.partial = el.querySelector('.acc-button-confirm-release');
        this.accept.changeSeat = el.querySelector('.acc-button-confirm-seat-change');
        this.accept.changeTicket = el.querySelector('.acc-button-confirm-ticket-change');

        this.alerts = {};
        this.alerts.partial = el.querySelector('.partial-release-prompt');
        this.alerts.changeSeat = el.querySelector('.seat-change-prompt');
        this.alerts.changeTicket = el.querySelector('.ticket-change-prompt');

        this.releasingCount = el.querySelector('.releasing-count');
        this.releasingAmount = el.querySelector('.releasing-amount');
        this.initialReleasingCount = this.releasingCount.innerHTML;
        this.initialReleasingAmount = this.releasingAmount.innerHTML;

        this._change = this._change.bind(this);
        this._immediate = this._immediate.bind(this);
        this._showCheckboxes = this._showCheckboxes.bind(this);
        this._onChangeSeats = this._onChangeSeats.bind(this);
        this._onChangeMultipleSeats = this._onChangeMultipleSeats.bind(this);
        this._onChangeTickets = this._onChangeTickets.bind(this);
        this._onRelease = this._onRelease.bind(this);
        this._onReset = this._onReset.bind(this);
        this._hideAlerts = this._hideAlerts.bind(this);
        this._updateMode = this._updateMode.bind(this);
        this.reset = this.reset.bind(this);
        this.itemChanged = this.itemChanged.bind(this);

        this.reset = this._change(this.reset);
        this.itemChanged = this._change(this.itemChanged);
        this._immediate = this._change(this._immediate);
        this._showCheckboxes = this._change(this._showCheckboxes);
        this._onChangeTickets = this._change(this._onChangeTickets);


        if (this.buttons.changeSeats)
            this.buttons.changeSeats.addEventListener('click', this._onChangeSeats);
        if (this.accept.changeSeat)
            this.accept.changeSeat.addEventListener('click', this._onChangeMultipleSeats);
        if (this.buttons.changeTickets)
            this.buttons.changeTickets.addEventListener('click', this._onChangeTickets);
        if (this.buttons.release)
            this.buttons.release.addEventListener('click', this._onRelease);
        if (this.buttons.reset)
            this.buttons.reset.addEventListener('click', this._onReset);

        this.reset();
    }

    _hideAlerts() {
        this.alerts.partial.style.display = 'none';
        this.alerts.changeSeat.style.display = 'none';
        this.alerts.changeTicket.style.display = 'none';
    }

    _change(fn) {
        return (...args) => {
            if (this.changing)
                return;
            this.changing = true;
            try {
                return fn(...args);
            } finally {
                this.changing = false;

                let count = 0;
                let amount = 0;
                let anyChecked = false;
                switch (this.mode) {
                    default:
                        for (const i of this.items) {
                            if (i.checked) {
                                anyChecked = true;

                                count++;
                                if (i.data.type != 4 && i.data.type != 8)
                                    amount += i.data.unitPrice + i.data.serviceFee;
                            }
                        }
                        break;
                    case ReservationMode.changeTicket:
                        for (const i of this.items) {
                            if (i.template && i.template.id !== i.data.ticketId) {
                                count++;
                                anyChecked = true;
                                amount += i.template.amount - (i.data.unitPrice + i.data.serviceFee);
                            }
                        }
                        break;
                }
                this._updateMode(anyChecked);

                if (anyChecked) {
                    this.releasingCount.innerHTML = count;

                    this.releasingAmount.innerHTML = formatCurrency(amount);
                } else {
                    this.releasingCount.innerHTML = this.initialReleasingCount;
                    this.releasingAmount.innerHTML = this.initialReleasingAmount;
                }
            }
        };
    }

    _immediate() {
        this.mode = ReservationMode.initial;
        for (const i of this.items) {
            let checked = i.checked;
            i.hideCheckbox();
            i.set(checked);
        }
    }

    _updateMode(enableAccept) {

        this.accept.partial.classList.add('disabled');
        this.accept.changeSeat.classList.add('disabled');
        this.accept.changeTicket.classList.add('disabled');
        this.accept.partial.style.display = 'none';
        this.accept.changeTicket.style.display = 'none';
        this.accept.changeSeat.style.display = 'none';


        switch (this.mode) {
            case ReservationMode.initial:
                break;
            case ReservationMode.partialRelease:
                this.accept.partial.style.display = '';
                if (enableAccept)
                    this.accept.partial.classList.remove('disabled');
                break;
            case ReservationMode.changeSeat:
                this.accept.changeSeat.style.display = '';
                if (enableAccept)
                    this.accept.changeSeat.classList.remove('disabled');
                break;
            case ReservationMode.changeTicket:
                this.accept.changeTicket.style.display = '';
                if (enableAccept)
                    this.accept.changeTicket.classList.remove('disabled');
                break;
        }
    }

    _showCheckboxes(condition) {
        for (const i of this.items) {
            i.hideCheckbox();
        }
        let checkedCount = 0;
        if (condition) {
            for (const i of this.items) {
                if (condition(i)) {
                    i.showCheckbox();
                    checkedCount++;
                }
            }
        } else {
            for (const i of this.items) {
                if (i.data.canRelease) {
                    i.showCheckbox();
                    checkedCount++;

                    for (const j of this.items) {
                        if (j.data.releaseKey === i.data.releaseKey) {
                            j.showCheckbox();
                        }
                    }
                }
            }
        }
        return checkedCount;
    }

    _onChangeSeats(e) {        
        this.mode = ReservationMode.changeSeat;
        switch (this._showCheckboxes(i => i.data.canChangeSeat)) {
            default:
                this._hideAlerts();
                this.alerts.changeSeat.style.display = '';
                this._updateMode(true);

                e.preventDefault();
                return false;
            case 1:
                this._immediate();
                if (this.hasSeasonChecked()) {
                    $('#' + this.modal.id).modal('show');
                    e.preventDefault();
                    return false;
                }
                return true;
            case 0:
                e.preventDefault();
                this.mode = ReservationMode.initial;
                return false;
        }
    }

    _onChangeMultipleSeats(e) {        
        if (this.hasSeasonChecked()) {
            e.preventDefault();
            $('#' + this.modal.id).modal('show');
            return false;
        }
    }

    _onChangeTickets(e) {
        this.mode = ReservationMode.changeTicket;

        let count = 0;
        for (const i of this.items) {
            i.hideCheckbox();
            if (i.data.canChangeTicketType) {
                i.showDropdown();
                count++;
            }
        }

        if (count) {
            this._hideAlerts();
            this.alerts.changeTicket.style.display = '';
            this._updateMode(true);
        }
        e.preventDefault();
        return false;
    }

    _onRelease(e) {
        let partialRelease = false;
        let releaseKey = null;
        for (const i of this.items) {
            if (i.data.canRelease) {
                if (releaseKey && releaseKey !== i.data.releaseKey) {
                    partialRelease = true;
                    break;
                }
                releaseKey = i.data.releaseKey;
            }
        }


        if (partialRelease) {
            this.mode = ReservationMode.partialRelease;
            switch (this._showCheckboxes()) {
                default:
                    this._hideAlerts();
                    this.alerts.partial.style.display = '';
                    this._updateMode(true);

                    e.preventDefault();
                    return false;
                case 1:
                    this._immediate();
                    return true;
                case 0:
                    this.mode = ReservationMode.initial;
                    e.preventDefault();
                    return false;
            }
        } else {
            return true;
        }
    }

    _onReset(e) {
        e.preventDefault();
        this.reset();
        return false;
    }

    reset() {
        this._hideAlerts();
        for (const i of this.items) {
            i.hideCheckbox();
            i.hideDropdown();
        }
        this.mode = ReservationMode.initial;
        return false;
    }

    itemChanged(item) {
        const itemKey = item.data.releaseKey;
        const checked = item.checked;

        switch (this.mode) {
            case ReservationMode.partialRelease:
                for (const i of this.items) {
                    if (i.data.releaseKey === itemKey)
                        i.set(checked);
                }
                break;
            case ReservationMode.changeTicket:
                break;
        }
    }

    hasSeasonChecked() {
        for (const i of this.items) {
            if (i.data.isSeason && i.checked) {
                return true;
            }
        }
    }
}

class ReservationItem {
    constructor(el, reservation) {
        this.el = el;
        this.reservation = reservation;
        this.cb = el.querySelector('input[type=checkbox]');
        this.ttdDisplay = el.querySelector('.ttd-display');
        this.ttdSelect = el.querySelector('.ttd-select');
        this.checked = true;
        this.checkboxEnabled = true;
        this.dropdownEnabled = true;

        this._onCheckedChange = this._onCheckedChange.bind(this);
        this._onDropdownChange = this._onDropdownChange.bind(this);
        this.set = this.set.bind(this);
        this.showCheckbox = this.showCheckbox.bind(this);
        this.hideCheckbox = this.hideCheckbox.bind(this);
        this.showDropdown = this.showDropdown.bind(this);
        this.hideDropdown = this.hideDropdown.bind(this);

        this.data = JSON.parse(el.dataset.item);

        this.cb.addEventListener('change', this._onCheckedChange);
        if (this.ttdSelect)
            this.ttdSelect.addEventListener('change', this._onDropdownChange);
    }

    _onCheckedChange(e) {
        if (this.checkboxEnabled) {
            this.checked = e.target.checked;
            this.reservation.itemChanged(this);
            return true;
        } else {
            this.cb.checked = false;
            e.preventDefault();
            return false;
        }
    }

    _onDropdownChange(e) {
        if (this.dropdownEnabled) {
            let selectedOption = e.target.selectedOptions[0];

            if (selectedOption) {
                if (selectedOption.dataset.template)
                    this.template = JSON.parse(selectedOption.dataset.template)
                else
                    this.template = null
                this.reservation.itemChanged(this);
                return true;
            }
        }
        e.preventDefault();
        return false;
    }

    set(checked) {
        this.cb.checked = checked;
        this.checked = checked;
    }


    showCheckbox() {
        this.hideDropdown();
        this.set(true);
        this.checkboxEnabled = true;

        $(this.el).find('.checkbox-td').removeAttr('hidden');
        $('.checkbox-th').removeAttr('hidden');


    }

    hideCheckbox() {
        this.set(false);
        this.checkboxEnabled = false;
        $(this.el).find('.checkbox-td').attr('hidden', true);
        $('.checkbox-th').attr('hidden', true);

    }

    showDropdown() {
        this.dropdownEnabled = true;
        this.hideCheckbox();
        if (this.ttdSelect) {
            $('.ticket-name-on-change').attr('hidden', true);
            this.ttdSelect.selectedIndex = 0;
            this.ttdSelect.style.display = '';

            if (this.ttdDisplay)
                this.ttdDisplay.style.display = 'none';
        }
    }

    hideDropdown() {
        this.dropdownEnabled = false;
        if (this.ttdSelect) {
            $('.ticket-name-on-change').removeAttr('hidden');

            this.ttdSelect.style.display = 'none';

            if (this.ttdDisplay)
                this.ttdDisplay.style.display = '';
        }
    }
}